/**
 * Cart Compatibility Check
 *
 * Checks whether a product can be added to the cart based on
 * collection compatibility restrictions set via metafields.
 *
 * Usage:
 *   window.CartCompat.canAdd(collectionHandlesString).then(result => {
 *     if (!result.allowed) showWarning(result.message, 5000);
 *   });
 */
window.CartCompat = (function() {
    var _cache = null;
    var _cacheTime = 0;
    var CACHE_TTL = 3000; // 3 seconds

    function fetchRestrictions() {
        var now = Date.now();
        if (_cache && (now - _cacheTime) < CACHE_TTL) {
            return Promise.resolve(_cache);
        }
        return fetch(window.routes.root + '/cart?view=ajax_compat_check', { credentials: 'same-origin' })
            .then(function(r) { return r.json(); })
            .then(function(data) {
                _cache = data;
                _cacheTime = Date.now();
                return data;
            });
    }

    function invalidateCache() {
        _cache = null;
        _cacheTime = 0;
    }

    function canAdd(collectionHandlesStr, quantity, limitData) {
        if (!collectionHandlesStr) {
            return Promise.resolve({ allowed: true, message: '' });
        }

        var requestedQuantity = parseInt(quantity, 10) || 1;
        var orderLimit = limitData || {};

        return fetchRestrictions().then(function(data) {
            if (orderLimit.maxQty && orderLimit.maxHandle) {
                var currentCollectionQty = parseInt((data.collection_quantities || {})[orderLimit.maxHandle], 10) || 0;
                var maxQty = parseInt(orderLimit.maxQty, 10) || 0;
                if (maxQty > 0 && currentCollectionQty + requestedQuantity > maxQty) {
                    var label = orderLimit.maxLabel || orderLimit.maxHandle;
                    var remainingQty = Math.max(maxQty - currentCollectionQty, 0);
                    return {
                        allowed: false,
                        message: remainingQty > 0
                            ? 'You can only add ' + remainingQty + ' more item(s) from ' + label + '.'
                            : 'Maximum ' + maxQty + ' per order (' + label + ') is already in your cart.'
                    };
                }
            }

            if (!data.restricted) {
                return { allowed: true, message: '' };
            }

            var productHandles = collectionHandlesStr.split(',').map(function(h) {
                return h.trim();
            }).filter(function(h) { return h.length > 0; });

            for (var i = 0; i < data.restricted_collections.length; i++) {
                var rc = data.restricted_collections[i];
                var allowed = rc.compatible_handles;

                // Check if this product belongs to at least one compatible collection
                var isCompatible = false;
                for (var j = 0; j < productHandles.length; j++) {
                    if (allowed.indexOf(productHandles[j]) !== -1) {
                        isCompatible = true;
                        break;
                    }
                }

                if (!isCompatible) {
                    return {
                        allowed: false,
                        message: 'This item cannot be purchased with ' + rc.title + ' pre-order items. Please remove the pre-order item first or shop from compatible collections.'
                    };
                }
            }

            return { allowed: true, message: '' };
        });
    }

    // Listen for cart updates to invalidate cache
    document.addEventListener('cart-update', invalidateCache);

    return {
        canAdd: canAdd,
        invalidateCache: invalidateCache
    };
})();
